import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionIcon, Badge, Button } from '@mantine/core';
import { IconUsers } from '@tabler/icons-react';

import { AppTooltip } from '@/components/ui/AppTooltip';

import type { TeamButtonProps } from './TeamButton.types';
import styles from './TeamButton.module.css';

const ICON_SIZE_FULL = 16;
const ICON_SIZE_COMPACT = 18;

export const TeamButton = memo(function TeamButton({
  onlineCount,
  variant = 'full',
  onClick,
}: TeamButtonProps) {
  const { t } = useTranslation();

  if (variant === 'compact') {
    return (
      <AppTooltip labelKey="tooltips.team.viewMembers">
        <div className={styles.compactWrapper}>
          <ActionIcon
            variant="subtle"
            size="lg"
            onClick={onClick}
            aria-label={t('appShell.topBar.team')}
          >
            <IconUsers size={ICON_SIZE_COMPACT} />
          </ActionIcon>
          {onlineCount > 0 && (
            <Badge size="xs" variant="filled" className={styles.compactBadge}>
              {onlineCount}
            </Badge>
          )}
        </div>
      </AppTooltip>
    );
  }

  return (
    <AppTooltip labelKey="tooltips.team.viewMembers">
      <Button
        variant="default"
        size="sm"
        onClick={onClick}
        leftSection={<IconUsers size={ICON_SIZE_FULL} />}
        rightSection={
          onlineCount > 0 ? (
            <Badge size="sm" variant="filled" circle>
              {onlineCount}
            </Badge>
          ) : undefined
        }
      >
        {t('appShell.topBar.team')}
      </Button>
    </AppTooltip>
  );
});
